"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tau = exports.pi = exports.phi = exports.e = void 0;
var pi = Math.PI;
exports.pi = pi;
var tau = 2 * Math.PI;
exports.tau = tau;
var e = Math.E;
exports.e = e;
var phi = 1.6180339887498948; // eslint-disable-line no-loss-of-precision

exports.phi = phi;